import { userQueryKey } from 'state/queryKeyUtils';

export const displayPrefQueryKeys = {
  all: [{ scope: 'displayPref' }] as const,
  myDisplayPrefs: (userId?: number) =>
    [{ ...displayPrefQueryKeys.all[0], ...userQueryKey(userId) }] as const,
};
